import { withAuthenticationRequired } from '@auth0/auth0-react'
import { NotFound } from 'modules/NotFound'
import { Route, Routes } from 'react-router'
import { FullPage, ModalPage } from '../../components/layout'
import { useIsIFramed } from '../../hooks'
import { Appointment } from './Appointment'

const Page = () => {
  const Container = useIsIFramed() ? ModalPage : FullPage

  return (
    <Container>
      <Routes>
        <Route element={<Appointment />} path=":appointmentId/*" />
        <Route element={<NotFound />} path="*" />
      </Routes>
    </Container>
  )
}

const Appointments = withAuthenticationRequired(Page)

export { Appointments }
